const VersionTable = ({ versions, loading, onEdit, onDelete }) => {
  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <table className="min-w-full bg-white border">
      <thead>
        <tr className="bg-gray-100 text-left">
          <th className="px-4 py-2 border">Platform</th>
          <th className="px-4 py-2 border">Version</th>
          <th className="px-4 py-2 border">Actions</th>
        </tr>
      </thead>
      <tbody>
        {versions?.map((item) => (
          <tr key={item?.id} className="border-t">
            <td className="px-4 py-2">{item?.platform}</td>
            <td className="px-4 py-2">{item?.version}</td>
            <td className="border-b border-gray-100 px-2 py-2 text-right">
              <div className="inline-flex gap-2">
                <button
                  type="button"
                  onClick={() => onEdit(item)}
                  className="cursor-pointer rounded-md border border-gray-300 bg-white px-2 py-1">
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => onDelete(item?.id)}
                  className="cursor-pointer rounded-md border border-red-500 bg-red-50 px-2 py-1 text-red-700">
                  Delete
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default VersionTable;
